export default "__VITE_ASSET__BSuuwZvF__"